module.exports = __webpack_public_path__ + "static/media/one.1e45a9b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/one.svg
// module id = 166
// module chunks = 0